<template>
  <div class="animated fadeIn">
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> Action
      </template> -->
      <b-row>
        <b-col class="title">
          행위 로그
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="6">
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='username';so.skt='Username'">사용자명</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='addr';so.skt='Address'">IP 주소</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i class="fa fa-search-plus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="ko_fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
        <template slot="username" slot-scope="row">{{row.item.username}}</template>
        <template slot="source" slot-scope="row">{{row.item.source}}</template>
        <template slot="addr" slot-scope="row">{{row.item.addr}}</template>
        <template slot="agent" slot-scope="row">
          {{row.item.agent | truncate(40) }}
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="row.toggleDetails" size="sm" variant="outline-primary">상세</b-btn>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-card class="text-left">
            <pre>
              <JsonViewer
              v-if="row.item.info"
              :value="row.item.info"
              :expand-depth=5
              copyable
              boxed
              sort
              />
            </pre>
          </b-card>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center":limit="5" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
      </b-row>
    </b-card>
    <router-view @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
